import { Link } from "react-router-dom";
import type { OrgMember } from "@/lib/types";

interface OrgNameProps {
  member: OrgMember;
  className?: string;
}

// mem_no > 0 이면 회원 상세(/members/:no)로 이동하는 링크 + 호버 밑줄.
// mem_no === 0 이면 명부에 없는 사람이므로 링크 없이 글자만 표시한다.
export default function OrgName({ member, className = "" }: OrgNameProps) {
  const text = String(member.name ?? "").trim();
  if (!text) return null;

  if (Number(member.mem_no) > 0) {
    return (
      <Link
        to={`/members/${member.mem_no}`}
        className={`cursor-pointer underline-offset-2 hover:underline hover:text-primary-700 transition-colors ${className}`}
      >
        {text}
      </Link>
    );
  }

  return <span className={className}>{text}</span>;
}